// placement constants
// NOTE: these aren't exported from Popper, but they are copied from:
// @popperjs/core/src/enums.js
export const TOOLTIP_AUTO: 'auto' = 'auto'
export const TOOLTIP_AUTO_START: 'auto-start' = 'auto-start'
export const TOOLTIP_AUTO_END: 'auto-end' = 'auto-end'

export const TOOLTIP_TOP: 'top' = 'top'
export const TOOLTIP_TOP_START: 'top-start' = 'top-start'
export const TOOLTIP_TOP_END: 'top-end' = 'top-end'

export const TOOLTIP_RIGHT: 'right' = 'right'
export const TOOLTIP_RIGHT_START: 'right-start' = 'right-start'
export const TOOLTIP_RIGHT_END: 'right-end' = 'right-end'

export const TOOLTIP_BOTTOM: 'bottom' = 'bottom'
export const TOOLTIP_BOTTOM_START: 'bottom-start' = 'bottom-start'
export const TOOLTIP_BOTTOM_END: 'bottom-end' = 'bottom-end'

export const TOOLTIP_LEFT: 'left' = 'left'
export const TOOLTIP_LEFT_START: 'left-start' = 'left-start'
export const TOOLTIP_LEFT_END: 'left-end' = 'left-end'

// strategy constants
// NOTE: these aren't exported from Popper, but they are copied from:
// @popperjs/core/src/types.js
export const TOOLTIP_ABSOLUTE: 'absolute' = 'absolute'
export const TOOLTIP_FIXED: 'fixed' = 'fixed'
